import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";
import { catchError, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isProd = environment.production;
  token = ""
  cookie = "g7d3uel8h6btei86tvmurqd2gv"

  meBody = {
    auth_token: this.cookie,
    xsrf_token: "",
  };

  constructor(private auth: AuthService, public snackBar: MatSnackBar) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to set necessary credentials and headers
    if (!req.url.endsWith("amazonaws.com")) {
      req = req.clone({
        withCredentials: true,
      });
      if (this.auth.getToken()) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${this.auth.getToken()}`,
          },
        });
      }
    }

    if (req.url.endsWith("/auth/me") && req.method === "POST") {
      req = req.clone({
        body: this.meBody,
      });
    }

    if (!this.isProd) {
      if (this.auth.getToken()) {
        req = req.clone({
          headers: req.headers.set("force-cookie", this.cookie),
        });
      }
    } else {
      if (this.token) {
        req = req.clone({
          headers: req.headers.set("X-SC-CSRF-Token", this.token),
        });
      }
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        // Check for HttpResponse and handle X-XSRF-TOKEN
        if (event instanceof HttpResponse) {
          if (event.headers.get("X-XSRF-TOKEN")) {
            this.token = event.headers.get("X-XSRF-TOKEN");
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        this.handleError(err);
        return throwError(err);
      })
    );
  }

  handleError(error: HttpErrorResponse) {
    console.log(error);
    if (error.status >= 500) {
      this.snackBar.open("Internal server error", "X", {
        duration: 30000,
        verticalPosition: "bottom",
        panelClass: ["snackbar-error"],
      });
    }

    const chunkFailedMessage = /Loading chunk/;
    if (chunkFailedMessage.test(error.message)) {
      console.log("chunk error called");
    }
  }
}
